import React, { useMemo, useEffect } from "react";
import {
  _LandingInnovationPetitPrinceRoot,
  _LandingInnovationPetitPrinceGrid,
} from "./LandingInnovationPetitPrince.styled";
import InnovationProductPetitPrince, {
  IInnovationProductPetitPrinceProps,
} from "./InnovationProductPetitPrince/InnovationProductPetitPrince";

export type ILandingInnovationPetitPrinceProduct<T extends any = any> = {
  id_product: string;
  imageId: string;
  staticImageSrc?: string;
  title: string;
  description?: React.ReactNode;
  composition?: string;
  price?: string;
  priceSubtitle?: string;
  ctaLabel?: string;
  color?: string;
  descriptionColor?: string;
  displayFromMention?: string;
  displayPrice?: boolean;
  compactComposition?: boolean;
} & T;

interface ILandingInnovationPetitPrinceProps<T extends any = any> {
  products?: ILandingInnovationPetitPrinceProduct<T>[];
  onClickProduct?: (product: ILandingInnovationPetitPrinceProduct<T>) => void;
  renderProduct?: (
    data: IInnovationProductPetitPrinceProps,
    index: number
  ) => React.ReactNode;
}

const LandingInnovationPetitPrince = <T extends any = any>(
  props: ILandingInnovationPetitPrinceProps<T>
) => {
  const { products, onClickProduct, renderProduct } = props;

  const productList = useMemo(() => {
    return products?.slice(0, 4) || [];
  }, [products]);

  const itemRenderer = (
    product: ILandingInnovationPetitPrinceProduct<T>,
    index: number
  ) => {
    const _data: IInnovationProductPetitPrinceProps = {
      className: "innovation-product-petit-prince-item",
      product: product,
      onClick: onClickProduct,
      compactComposition: product.compactComposition,
    };
    return (
      <React.Fragment key={product.id_product}>
        {renderProduct ? (
          renderProduct(_data, index)
        ) : (
          <InnovationProductPetitPrince key={product.id_product} {..._data} />
        )}
      </React.Fragment>
    );
  };

  return (
    <_LandingInnovationPetitPrinceRoot className="landing-innovation-petit-prince">
      <_LandingInnovationPetitPrinceGrid>
        {productList?.map((product, index) => {
          return itemRenderer(product, index);
        })}
      </_LandingInnovationPetitPrinceGrid>
    </_LandingInnovationPetitPrinceRoot>
  );
};

export default React.memo(
  LandingInnovationPetitPrince
) as typeof LandingInnovationPetitPrince;
